import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 688C66E3-B436-4900-83EF-ADCEBBEDE627
 * name send-check
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-check.svg
 * tags
 */
export const SendCheckIcon = createSvgIcon(<><path d="M2 3V10L17 12L2 14V21L23 12M22 15.5L18.5 19L16.5 17L15 18.5L18.5 22L23.5 17Z" /></>, 'SendCheckIcon');
export default SendCheckIcon